import { render, staticRenderFns } from "./TmDataError.vue?vue&type=template&id=2b9e83d9&"
import script from "./TmDataError.vue?vue&type=script&lang=js&"
export * from "./TmDataError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports